// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2ik03","errorLogs":"EditorFooter_errorLogs__2-CjM"};